import { useState, useEffect } from "react";

/**
 * Custom hook for a single routing number with validation
 * @param {string} initialValue - initial value (can be from API)
 */
export const useSingleRoutingNumber = (initialValue = "") => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState("");

  // ABA checksum validation
  const validate = (num) => {
    if (!/^\d{9}$/.test(num)) return "Please enter a valid 9-digit routing number.";

    const digits = num.split("").map(Number);
    const checksum =
      3 * (digits[0] + digits[3] + digits[6]) +
      7 * (digits[1] + digits[4] + digits[7]) +
      (digits[2] + digits[5] + digits[8]);

    if (checksum % 10 !== 0) return "Invalid routing number. Please check again.";

    return "";
  };

  const handleChange = (input) => {
    const cleanValue = input.replace(/\D/g, "");
    setValue(cleanValue);

    if (cleanValue.length === 9) {
      setError(validate(cleanValue));
    } else {
      setError("Routing number must be 9 digits.");
    }
  };

  // Allow updating from external source (API)
  const setFromAPI = (apiValue) => {
    const cleanValue = apiValue.replace(/\D/g, "");
    setValue(cleanValue);
    if (cleanValue.length === 9) {
      setError(validate(cleanValue));
    } else {
      setError(cleanValue ? "Routing number must be 9 digits." : "");
    }
  };

  return {
    value,
    error,
    handleChange,
    setValue,
    validate,
    setFromAPI,
  };
};
